import React from "react";
import ProductCard from "../components/ProductCard";
import Layout from "../components/Layout";
import styles from "./Sprats.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const tomatoProducts = [
  { key: "valmis_kilka_fried_240", image: "/assets/products/canned/tomato/tomato-valmis-kilka-fried-240.jpg" },
  { key: "valmis_chopped_fish_240", image: "/assets/products/canned/tomato/tomato-valmis-chopped-fish-240.jpg" },

  { key: "ventspils_riga_sardine_240", image: "/assets/products/canned/tomato/tomato-ventspils-riga-sardine-240.jpg" },
  { key: "ventspils_mackerel_240", image: "/assets/products/canned/tomato/tomato-ventspils-mackerel-240.jpg" },
  { key: "ventspils_chopped_fish_240", image: "/assets/products/canned/tomato/tomato-ventspils-chopped-fish-240.jpg" },
  { key: "ventspils_kilka_fried_240", image: "/assets/products/canned/tomato/tomato-ventspils-kilka-fried-240.jpg" },
  { key: "ventspils_kilka_fried_190", image: "/assets/products/canned/tomato/tomato-ventspils-kilka-fried-190.jpg" },
];

const Tomato = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <h2 className={styles.heading}>{t("tomato.title")}</h2>

      <div className={styles.grid}>
        {tomatoProducts.map((product) => (
          <ProductCard
            key={product.key}
            title={t(`tomato.products.${product.key}.title`)}
            weight={t(`tomato.products.${product.key}.weight`)}
            description={t(`tomato.products.${product.key}.description`)}
            image={product.image}
          />
        ))}
      </div>
    </Layout>
  );
};

export default Tomato;
